import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500">
          <span className="h-px w-6 bg-accent-500" />
          {eyebrow}
        </p>
        <h2 className="mt-2 font-heading text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && <p className="mt-2 text-sm leading-relaxed text-foreground-500">{description}</p>}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit shrink-0 cursor-pointer items-center gap-1.5 rounded-full border border-background-300/80 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}